import { NgModule } from '@angular/core';
import { DefaultComponent } from './default.component';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from 'src/app/modules/pages/home/home.component';
import { CoursesComponent } from 'src/app/modules/pages/courses/courses.component';
import { LessonsComponent } from 'src/app/modules/pages/lessons/lessons.component';
import { RunComponent } from 'src/app/modules/pages/run/run.component';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http'
import { ReactiveFormsModule, FormsModule  } from '@angular/forms';
import { LessonListComponent } from 'src/app/shared/components/lesson-list/lesson-list.component';
import { TaskListComponent } from 'src/app/shared/components/task-list/task-list.component';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
import { MaterialModule } from 'src/app/material-module';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ProfileComponent } from 'src/app/modules/pages/profile/profile.component';
import { SchemaFormModule, WidgetRegistry, DefaultWidgetRegistry } from "ngx-schema-form";
import { RunButtonWidget } from 'src/app/shared/widgets/schemaCustom/runButton.widget';
import { AdmTasksComponent } from 'src/app/modules/admin/pages/crud/adm-tasks/adm-tasks.component';
import { AdmLessonsComponent } from 'src/app/modules/admin/pages/crud/adm-lessons/adm-lessons.component';
import { AdmCoursesComponent } from 'src/app/modules/admin/pages/crud/adm-courses/adm-courses.component';
import { WidgetRegistryCustom } from 'src/app/shared/widgets/schemaCustom/WidgetRegisty';
import { CheckboxWidget } from 'src/app/shared/widgets/schemaCustom/checkbox.widget';
import { FieldsComponent } from 'src/app/shared/admin/widgets/fields/fields.component';
import { AdminMainComponent } from 'src/app/modules/admin/pages/admin-main/admin-main.component';
import { TokenInterceptor } from 'src/app/core/http/interceptors/token.interceptor';
import { AdmGroupsComponent } from 'src/app/modules/admin/pages/crud/adm-groups/adm-groups.component';
import { AdmGroupUsersComponent } from 'src/app/modules/admin/pages/crud/adm-group-users/adm-group-users.component';
import { CoursesListComponent } from 'src/app/shared/components/courses-list/courses-list.component';
import { MycoursesComponent } from 'src/app/modules/pages/mycourses/mycourses.component';
import { ParentComponent } from 'src/app/modules/pages/parent/parent.component';
import { LessonTheoryComponent } from 'src/app/modules/pages/lesson-theory/lesson-theory.component';
import { NumberToArrayPipe } from 'src/app/shared/pipe/number-to-array.pipe';
import { LessonStringPipe } from 'src/app/shared/pipe/lesson-string.pipe';
import { HeaderComponent } from 'src/app/core/headers/default-header/header.component';
import { FooterComponent } from 'src/app/core/footer/footer.component';
import { BreadcrumbModule } from 'angular-crumbs';
import { LoginModule } from 'src/app/modules/components/login/login.module';
import { StringWidget } from 'src/app/shared/widgets/schemaCustom/string.widget';
import { PollComponent } from 'src/app/modules/pages/poll/poll.component';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { DateWidget } from 'src/app/shared/widgets/schemaCustom/date.widget';


const routes: Routes = [
    {
      path: '',
      component: HomeComponent,
      redirectTo: 'courses',
      pathMatch: 'full'
    },
    {
      path: 'mycourses',
      component: MycoursesComponent
    },
    {
      path: 'courses',
      component: ParentComponent,
      data: {
        breadcrumb: 'Все курсы'
      },
      children: [
        {
          path: '',
          component: CoursesComponent,
        },
        {
          path: ':course',
          component: ParentComponent,
          data: {
            breadcrumb: 'Конкретный курс'
          },
          children: [
            {
              path: '',
              component: LessonsComponent,
            }
          ]
        },
      ]
    },
    {
      path: 'courses/:course/run/:task',
      component: RunComponent,
    },
    {
      path: 'profile',
      component: ProfileComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'theory/:lesson',
      component: LessonTheoryComponent,
    },
    {
      path: 'admin',
      component: AdminMainComponent,
      canActivate: [AuthGuard],
      data: { roles: ['superadmin','admin','creator'] },
      children: [
      {
        path: 'courses',
        component: AdmCoursesComponent,
        canActivate: [AuthGuard],
        data: { roles: ['creator','superadmin'] },
      },
      {
        path: 'groups',
        component: AdmGroupsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['superadmin'] },
      },
      {
        path: 'gusers',
        component: AdmGroupUsersComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin','superadmin'] },
      },
      {
        path: 'course/:course',
        component: AdmLessonsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['creator','superadmin'] },
      },
      {
        path: 'course/:course/lesson/:lesson',
        component: AdmTasksComponent,
        canActivate: [AuthGuard],
        data: { roles: ['creator','superadmin'] },
      }
    ]
    }
  
]




@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    DefaultComponent,
    HomeComponent,
    CoursesComponent,
    MycoursesComponent,
    LessonsComponent,
    RunComponent,
    ParentComponent,
    LessonListComponent,
    TaskListComponent,
    ProfileComponent,
    RunButtonWidget,
    LessonTheoryComponent,
    FieldsComponent,
    AdmTasksComponent,
    AdmLessonsComponent,
    AdmCoursesComponent,
    CheckboxWidget,
    CoursesListComponent,
    AdminMainComponent,
    AdmGroupsComponent,
    AdmGroupUsersComponent,
    StringWidget,
    DateWidget
  ],
  entryComponents: [
    LoginComponent,
    StringWidget
  ],
  imports: [
      SchemaFormModule.forRoot(),
      CommonModule,
      RouterModule.forChild(routes),
      HttpClientModule,
      FormsModule,
      BreadcrumbModule,
      PipesModule,
      LoginModule,
      ReactiveFormsModule,
      MaterialModule,
      CodemirrorModule,
      NgCircleProgressModule.forRoot(),
  ],
  providers: [
    {
      provide: WidgetRegistry,
      useClass: WidgetRegistryCustom,
    },
  ],
  exports: [
      DefaultComponent,
      FieldsComponent
  ]
})
export class DefaultModule { }
